import styled, { createGlobalStyle } from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2147483645;
`;

interface ModalContentProps {
  height?: string;
}

export const ModalContent = styled.div<ModalContentProps>`
  position: absolute;
  margin: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  height: auto;
  z-index: 2147483647;
  background: #14171c;
  border-radius: 2px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.2);
  cursor: default;
  @media only screen and (max-width: 399px) {
    width: 300px;
  }
`;

export const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2147483646;
  left: 0;
  top: 0;
`;

interface HeadingProps {
  headingColor?: string;
}

export const Heading = styled.div<HeadingProps>`
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding: 0 10px;
  background: ${(props) => props.headingColor || props.theme.primaryColor};
  color: #fff;
  font-family: "Exo 2", sans-serif;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
`;

export const Content = styled.div`
  padding: 10px 0;
  margin: 0 10px;
  border-bottom: 1px solid #e9e9e9;
`;

export const Footer = styled.div`
  padding: 10px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HelpWidgetStyle = createGlobalStyle`
  iframe[name="JSD widget"] {
    z-index: 2147483642 !important;
  }
`;
